import {Link} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import emailjs from '@emailjs/browser';

function Contact(props) {

  const [messageIsSent, setMessageIsSent] = useState(false);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    if (document.getElementById('email').value !== '' &&
        document.getElementById('name').value !== '' &&
        document.getElementById('message').value !== '') {
    emailjs
      .sendForm('service_8re2v49', 'template_0hdixvq', form.current, 
      'RWizanIvkumNJFqQ5')
      .then(
        (result) => {
          console.log(result.text);
          if (result.text === 'OK') {
            setMessageIsSent(true);
          }
        },
        (error) => {
          console.log('FAILED...', error.text);
          
        },
      );
    } else {
      alert('Please include name, email address, and a message.');
    }
  };


if (messageIsSent === false) {
    return (
        <div>
          
      <div className='bodyContainer' style={{
        paddingTop: props.viewMode === 'desktop' || props.viewMode === 'tablet' ? '50px' :
        '0px'
      }}>
        <form ref={form} onSubmit={sendEmail} style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px', 
          alignItems: 'center'
          
        }}>
          <input style={{
            border: props.mode === 'light' ? '1px solid #28282b' : '1px solid #f1eee6',
            color: props.mode === 'light' ? '#28282b' : '#f1eee6'
          }} 
          type='text' name='user_name' id='name' placeholder='name'>
          </input>

          <input style={{
            border: props.mode === 'light' ? '1px solid #28282b' : '1px solid #f1eee6',
            color: props.mode === 'light' ? '#28282b' : '#f1eee6'
          }} type='email' name='user_email' id='email' placeholder='email address'></input>


          <input style={{
            border: props.mode === 'light' ? '1px solid #28282b' : '1px solid #f1eee6',
            color: props.mode === 'light' ? '#28282b' : '#f1eee6',
            height: '150px',
            textAlign: 'start',
          }} type='text' name='message' id='message' placeholder='message'></input>

          <input type='submit' id='sendMessage' value='send' style={{
            border: props.mode === 'light' ? '1px solid #28282b' : '1px solid #f1eee6',
            color: props.mode === 'light' ? '#28282b' : '#f1eee6'
          }} onClick={(e) => e.preventDefault}></input>
        </form>
      </div>
      </div>
      );
    } else if (messageIsSent === true) {
      return (
        <div className='bodyContainer' style={{
          paddingTop: props.viewMode === 'desktop' || props.viewMode === 'tablet' ? '50px' :
          '0px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px', 
          alignItems: 'center',
          justifyItems: 'center'
        }}>
          <h6 style={{
            border: props.mode === 'light' ? '1px solid #28282b' : '1px solid #f1eee6',
            color: props.mode === 'light' ? '#28282b' : '#f1eee6',
            borderRadius: '5px',
            height: '60px',
            transition: '.5s',
            width: '350px',
            textAlign: 'center',
            fontSize: '25px',
            fontWeight: '100',
            paddingTop: '2.5%'
            

          }}>Message Sent</h6>
          
          </div>
      )
    }
}

export default Contact